import { Injectable } from '@angular/core';
import { CommonModel } from '../models/common.model';
import { IncidentServiceBase } from '../services/incident-base.service';

@Injectable()
export class CommonIncidentService extends IncidentServiceBase<CommonModel> {
    constructor() {
        super('Common', () => new CommonModel());
    }
}
